// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__nqZJ9","wrap":"Layout_wrap__WHN0h","content":"Layout_content__UOgH6","contentFooter":"Layout_contentFooter__WRb1m"};